import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Footer from '../../Footer/Footer';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.colors.offWhite};
`;

const Content = styled.div`
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  width: 100%;
`;

const Card = styled.div`
  background: white;
  border-radius: 8px;
  padding: 3rem;
  text-align: center;
  box-shadow: ${props => props.theme.shadows.light};
  border: 1px solid ${props => props.theme.colors.greyBackground};
  margin: 2rem 0;
`;

const Icon = styled.div`
  font-size: 4rem;
  color: #F44336;
  margin-bottom: 1.5rem;
`;

const Title = styled.h1`
  color: ${props => props.theme.colors.text};
  margin-bottom: 1rem;
  font-size: 2rem;
`;

const FarmShopPaymentFailure = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Content>
        <Card>
          <Icon><FontAwesomeIcon icon={faExclamationTriangle} /></Icon>
          <Title>Payment Failed</Title>
          <p>Something went wrong processing your payment. Please try again.</p>
          <button onClick={() => navigate('/farm-shop')} style={{ marginTop: '1rem' }}>
            <FontAwesomeIcon icon={faArrowLeft} /> Back to Shop
          </button>
        </Card>
      </Content>
      <Footer />
    </Container>
  );
};

export default FarmShopPaymentFailure;

